import { dew as _chronoDew } from "../../../chrono";
import { dew as _ExtractTimezoneOffsetRefinerDew } from "../../../common/refiners/ExtractTimezoneOffsetRefiner";
import { dew as _configurationsDew } from "../../../configurations";
import { dew as _ZHHansCasualDateParserDew } from "./parsers/ZHHansCasualDateParser";
import { dew as _ZHHansDateParserDew } from "./parsers/ZHHansDateParser";
import { dew as _ZHHansDeadlineFormatParserDew } from "./parsers/ZHHansDeadlineFormatParser";
import { dew as _ZHHansRelationWeekdayParserDew } from "./parsers/ZHHansRelationWeekdayParser";
import { dew as _ZHHansTimeExpressionParserDew } from "./parsers/ZHHansTimeExpressionParser";
import { dew as _ZHHansWeekdayParserDew } from "./parsers/ZHHansWeekdayParser";
import { dew as _ZHHansMergeDateRangeRefinerDew } from "./refiners/ZHHansMergeDateRangeRefiner";
import { dew as _ZHHansMergeDateTimeRefinerDew } from "./refiners/ZHHansMergeDateTimeRefiner";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createConfiguration = exports.createCasualConfiguration = exports.parseDate = exports.parse = exports.strict = exports.casual = exports.hans = void 0;
  const chrono_1 = _chronoDew();
  const ExtractTimezoneOffsetRefiner_1 = __importDefault(_ExtractTimezoneOffsetRefinerDew());
  const configurations_1 = _configurationsDew();
  const ZHHansCasualDateParser_1 = __importDefault(_ZHHansCasualDateParserDew());
  const ZHHansDateParser_1 = __importDefault(_ZHHansDateParserDew());
  const ZHHansDeadlineFormatParser_1 = __importDefault(_ZHHansDeadlineFormatParserDew());
  const ZHHansRelationWeekdayParser_1 = __importDefault(_ZHHansRelationWeekdayParserDew());
  const ZHHansTimeExpressionParser_1 = __importDefault(_ZHHansTimeExpressionParserDew());
  const ZHHansWeekdayParser_1 = __importDefault(_ZHHansWeekdayParserDew());
  const ZHHansMergeDateRangeRefiner_1 = __importDefault(_ZHHansMergeDateRangeRefinerDew());
  const ZHHansMergeDateTimeRefiner_1 = __importDefault(_ZHHansMergeDateTimeRefinerDew());
  exports.hans = new chrono_1.Chrono(createCasualConfiguration());
  exports.casual = new chrono_1.Chrono(createCasualConfiguration());
  exports.strict = new chrono_1.Chrono(createConfiguration());
  function parse(text, ref, option) {
    return exports.casual.parse(text, ref, option);
  }
  exports.parse = parse;
  function parseDate(text, ref, option) {
    return exports.casual.parseDate(text, ref, option);
  }
  exports.parseDate = parseDate;
  function createCasualConfiguration() {
    const option = createConfiguration();
    option.parsers.unshift(new ZHHansCasualDateParser_1.default());
    return option;
  }
  exports.createCasualConfiguration = createCasualConfiguration;
  function createConfiguration() {
    const configuration = configurations_1.includeCommonConfiguration({
      parsers: [new ZHHansDateParser_1.default(), new ZHHansRelationWeekdayParser_1.default(), new ZHHansWeekdayParser_1.default(), new ZHHansTimeExpressionParser_1.default(), new ZHHansDeadlineFormatParser_1.default()],
      refiners: [new ZHHansMergeDateRangeRefiner_1.default(), new ZHHansMergeDateTimeRefiner_1.default()]
    });
    configuration.refiners = configuration.refiners.filter(refiner => !(refiner instanceof ExtractTimezoneOffsetRefiner_1.default));
    return configuration;
  }
  exports.createConfiguration = createConfiguration;
  //# sourceMappingURL=index.js.map
  return exports;
}